module.exports = __webpack_public_path__ + "img/alert-triangle.bcf0e25a.svg";